// PropertySearchResults.js
import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom'; // Import Link for navigation
import './PaymentsSearchResults.css';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_PROXY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const PaymentSearchResults = () => {
  const { customerId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { dataClient } = useOutletContext(); // Access dataClient

  const formData = location.state?.formData;

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const yearshistory = formData?.yearshistory;
  const taxyear = formData?.taxyear;
  const payoffDate = formData?.payoffDate ?? null;

  useEffect(() => {
    if (!formData) {
      // If formData is not available, redirect back to the search form
      navigate(`/customer/${customerId}`);
      return;
    }

    const fetchResults = async () => {
      try {
        const apiUrl = `/api/propertySearch/${customerId}`;
        const response = await apiClient.post(apiUrl, formData);
        setResults(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching property search results:', error);
        setError(error);
        setLoading(false);
      }
    };

    fetchResults();
  }, [customerId, formData, navigate]);

  const formatName = (name1, name2) => {
    if (name2 && name2.trim() !== '') {
      return `${name1} ${name2}`;
    }
    return name1;
  };

  const formatAddress = (address1, address2, city, state, zip) => {
    let fullAddress = address1;
    if (address2 && address2.trim() !== '') {
      fullAddress += `, ${address2}`;
    }
    fullAddress += `, ${city}, ${state} ${zip}`;
    return fullAddress;
  };
  
  if (loading) {
    return <div>Loading search results...</div>;
  }

  if (error) {
    return <div>Error fetching results: {error.message}</div>;
  }

  if (!dataClient) {
    return <div>Loading client data...</div>;
  }

  return (
    <div className="property-search-results">
      <h1><strong>Search Results for {dataClient.name}</strong></h1>
      {results.length > 0 ? (
        <ul className="results-list">
          {results.map((result) => (
            <li key={result.propertyTaxID} className="result-item">
              {/* Left Column: Property Details */}
              <div className="left-column">
                <div><strong>Tax ID:</strong> {result.propertyTaxID}</div>
                <div><strong>Owner Name:</strong> {formatName(result.propertyOwnerName1, result.propertyOwnerName2)}</div>
                <div><strong>Address:</strong> {formatAddress(
                  result.propertyOwnerAddress1,
                  result.propertyOwnerAddress2,
                  result.propertyOwnerCity,
                  result.propertyOwnerState,
                  result.propertyOwnerZip
                )}</div>
                {/* Add more fields as necessary */}
              </div>

              {/* Right Column: Detail Page Link */}
              <div className="right-column">
                <Link to={`/customer/${customerId}/propertyPayments/${result.propertyTaxID}/${taxyear}`} state={{ payoffDate }} className="detail-link">
                  Status
                </Link>
                <Link to={`/customer/${customerId}/history/${result.propertyTaxID}/${taxyear}/${yearshistory}`} state={{ payoffDate }} className="detail-link">
                  History
                </Link>
                <Link to={`/customer/${customerId}/propertyPayments/${result.propertyTaxID}/${taxyear}`} className="detail-link">
                  Pay
                </Link>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>No results found.</p>
      )}
    </div>
  );
};

export default PaymentSearchResults;
